import script from "./MillionUsersTestimonial.vue?vue&type=script&setup=true&lang=ts"
export * from "./MillionUsersTestimonial.vue?vue&type=script&setup=true&lang=ts"

import "./MillionUsersTestimonial.vue?vue&type=style&index=0&id=2862e31b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2862e31b"]])

export default __exports__